import React, { useEffect, useMemo, useState } from "react";
import "../../Scheduler/components/SchedulerFilters/SchedulerFilters.scss";
import { useAllActiveOffices } from "repositories/scheduler-repository";
import { useQueryClient } from "react-query";
import { getAssignedToYouAllActiveParams } from "hooks/useOfficeContextOfficeList";
import useEffectiveOwnerId from "hooks/useEffectiveOwnerId";
import constants from "../../../../constants";

function OfficeFilter({
  setOfficeFilter,
  selectedOffice,
  t,
  isStaff = false,
  accountOwnerId = null,
}) {
  const queryClient = useQueryClient();
  const { isOfficeNavigationContext } = useEffectiveOwnerId();
  const {
    data: officeContextOfficeData,
    refetch: refetchOfficeContextOffices,
  } = useAllActiveOffices(
    1,
    constants.ACTIVE_OFFICES_PAGE_SIZE,
    getAssignedToYouAllActiveParams(accountOwnerId),
    "",
    {
      enabled: !isStaff && isOfficeNavigationContext && accountOwnerId != null,
    },
  );
  const { data: globalOfficeData, refetch: refetchGlobalOffices } =
    useAllActiveOffices(
      1,
      constants.ACTIVE_OFFICES_PAGE_SIZE,
      getAssignedToYouAllActiveParams(accountOwnerId),
      "",
      {
        enabled:
          !isStaff && !isOfficeNavigationContext && accountOwnerId != null,
      },
    );
  const { data: assignedToYouOfficeData } = useAllActiveOffices(
    1,
    constants.ACTIVE_OFFICES_PAGE_SIZE,
    getAssignedToYouAllActiveParams(accountOwnerId),
    "",
    { enabled: isStaff },
  );
  const [selectAll, setSelectAll] = useState(false);

  const mapAllActiveOffices = (officeData) => {
    if (!officeData?.data?.length) return [];
    return officeData.data
      .map((office) => ({
        id: office.id ?? office.officeId,
        name: office.name ?? office.officeName ?? "",
      }))
      .filter((office) => office.id != null);
  };

  const data = useMemo(() => {
    if (isStaff) {
      return mapAllActiveOffices(assignedToYouOfficeData);
    }
    if (isOfficeNavigationContext) {
      return mapAllActiveOffices(officeContextOfficeData);
    }
    return mapAllActiveOffices(globalOfficeData);
  }, [
    isOfficeNavigationContext,
    officeContextOfficeData,
    isStaff,
    assignedToYouOfficeData,
    globalOfficeData,
  ]);

  useEffect(() => {
    if (isStaff) return;
    queryClient.invalidateQueries(["/Office/AllActive"]);
    if (isOfficeNavigationContext) {
      refetchOfficeContextOffices();
      return;
    }
    refetchGlobalOffices();
  }, [
    accountOwnerId,
    refetchGlobalOffices,
    refetchOfficeContextOffices,
    queryClient,
    isOfficeNavigationContext,
    isStaff,
  ]);

  useEffect(() => {
    if (selectedOffice?.length === data?.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedOffice, data]);

  const handleChange = (e, item) => {
    const offices = [...selectedOffice];
    const officeIndex = offices.findIndex((v) => +item.id === +v);
    if (e.target.checked) {
      offices.push(item.id);
    } else {
      if (officeIndex > -1) offices.splice(officeIndex, 1);
    }
    setOfficeFilter(offices);
    setSelectAll(false);
  };

  const handleAllChange = (e) => {
    setSelectAll(e.target.checked);
    if (e.target.checked) {
      setOfficeFilter(data?.length ? data?.map((item) => item.id) : []);
    } else {
      setOfficeFilter([]);
    }
  };
  return (
    <ul className={["filter-list"]}>
      {data?.length > 0 && (
        <ul>
          <li>
            <div className="ch-checkbox">
              <label>
                <input
                  type="checkbox"
                  onChange={handleAllChange}
                  checked={selectAll}
                />{" "}
                <span>{t("notes.allFilters")}</span>
              </label>
            </div>
          </li>
          <hr className="mr-4" />
        </ul>
      )}
      {data?.length > 0 &&
        data?.map((item, key) => (
          <li key={key}>
            <div className="ch-checkbox">
              <label>
                <input
                  type="checkbox"
                  onChange={(e) => handleChange(e, item)}
                  checked={selectedOffice.includes(item.id)}
                />{" "}
                <span> {item.name}</span>
              </label>
            </div>
          </li>
        ))}
    </ul>
  );
}

export default OfficeFilter;
